import LANGUAGES from "assets/data/language.data.json"
import * as Flags from "country-flag-icons/react/3x2"

import { CountryCode } from "@shared/types/countryCode"

interface CountryFlagProps {
  /**
   *  A CountryCode instance or a string that can be parsed into a CountryCode.
   *  The string should be a valid ISO 3166-1 alpha-2 code.
   */
  code: CountryCode | string
}

interface CountryFlagRoundProps {
  language: (typeof LANGUAGES)[0]
}

/**
 * A (small) rectangular country flag component.
 * Used in dropdowns and selects where a compact flag representation is needed.
 */
export const CountryFlag = ({ code }: CountryFlagProps) => {
  const countryCode = typeof code === "string" ? CountryCode.parse(code) : code
  if (!countryCode) {
    return null
  }

  const FlagComponent = Flags[countryCode.alpha2]
  return <FlagComponent className="h-4 w-6 shrink-0 rounded-sm" />
}

/**
 * A round country flag component with border.
 * Used in the language switcher to display language options.
 */
export const CountryFlagRound = ({ language }: CountryFlagRoundProps) => {
  const countryCode = CountryCode.parse(language.icon)
  if (!countryCode) {
    return null
  }

  const FlagComponent = Flags[countryCode.alpha2]
  return (
    <div className="size-6 overflow-hidden !rounded-full border border-gray-100">
      <FlagComponent className="size-full scale-150 object-cover" />
    </div>
  )
}
